import { allowOnlyGuests } from '@/router/routerGuards'

import router from '@/router'

// Setup routes
export default () => {
  router.addRoute({
    path: '/forgot-password',
    component: () => import('../../components/OnboardingWrapper.vue'),
    children: [
      {
        path: '',
        name: 'forgot-password',
        components: {
          default: () => import('./resetPassword.vue'),
          geometricBackground: () => import('../../components/GeometricBackground.vue')
        },
        beforeEnter: allowOnlyGuests()
      },
      {
        path: 'check-email',
        name: 'forgot-password-check-email',
        component: () => import('./resetPasswordCheckEmail.vue'),
        beforeEnter: allowOnlyGuests()
      }
    ]
  })
  router.addRoute({
    path: '/azure-ad-password-reset',
    name: 'reset-password-callback',
    component: () => import('./resetPasswordCallback.vue'),
    beforeEnter: allowOnlyGuests()
  })
}
